import React, { useEffect, useState } from "react";
import classes from "./Messages.module.css";
import { SideBarMenu } from "../../../stories/SideBarMenu/SideBarMenu";
import { useHistory, useLocation } from "react-router-dom";
import ChatScreen from "./chat/chat";
import {
  ChatFilled,
  ChatOutlined,
  HomeFilled,
  Homeoutlined,
  InsightsFilled,
  InsightsOutlined,
  NotificationFilled,
  Notificationoutlined,
  ReviewFilled,
  ReviewOutlined,
  ScheduleFilled,
  ScheduleOutlined,
  ShortLogo,
} from "../../../constant/imagePath";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook";
import MessagesMobile from "./MessagesMobile";

const MessagesDesktop = () => {
  const history = useHistory();
  const location = useLocation();
  const sidebarMenus = [
    {
      icon: Homeoutlined,
      hoverIcon: HomeFilled,
      text: "Todo",
      activeText: "todo",
      onClick: () => history.push("/todo"),
    },
    {
      icon: Notificationoutlined,
      hoverIcon: NotificationFilled,
      text: "Notifications",
      activeText: "notifications",
      onClick: () => history.push("/notifications"),
    },
    {
      icon: ScheduleOutlined,
      hoverIcon: ScheduleFilled,
      text: "Schedule",

      activeText: "schedule",
      onClick: () => history.push("/schedule"),
    },
    {
      icon: ChatOutlined,
      hoverIcon: ChatFilled,
      text: "Chat",

      activeText: "chat",
      onClick: () => history.push("/chat"),
    },
    {
      icon: ReviewOutlined,
      hoverIcon: ReviewFilled,
      text: "Reviews",

      activeText: "reviews",
      onClick: () => history.push("/reviews"),
    },
    {
      icon: InsightsOutlined,
      hoverIcon: InsightsFilled,
      text: "Insights",
      activeText: "insights",

      onClick: () => history.push("/insights"),
    },
  ];
  return (
    <div className={[classes.StudentDetailsScreen].join(" ")}>
      <SideBarMenu
        logo={ShortLogo}
        items={sidebarMenus}
        state={location?.pathname?.split("/")[1]}
        customStyle={{ minHeight: "100vh", height: "auto" }}
      />

      <ChatScreen />
    </div>
  );
};

const Messages = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <MessagesMobile /> : <MessagesDesktop />;
};

export default Messages;
